import { combineEpics, createEpicMiddleware } from 'redux-observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/exhaustMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/mergeMap';
import ingestAssetsEpics from './ingestAssetsEpics';
import screenEpics from './screenEpics';
import userEpics from './userEpics';
import feedEpics from './feedEpics';
import agentEpics from './agentEpics';
import playlistEpics from './playlistEpics';
import playoutEpics from './playoutEpics';
export const rootEpic = combineEpics(
  ingestAssetsEpics,
  screenEpics,
  userEpics,
  feedEpics,
  agentEpics,
  playlistEpics,
  playoutEpics
);

export default createEpicMiddleware();
